"use strict";

exports.__esModule = true;
exports.default = exports.SectionHeading = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _useRandomId = _interopRequireDefault(require("../../hooks/useRandomId"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * The Section Heading component it helps in keeping the interest of respondents intact.
 */

const SectionHeading = exports.SectionHeading = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
    tag: Tag,
    className,
    title,
    subtitle,
    id: controlledId,
    children,
    ...attributes
  } = props;
  const classes = (0, _clsx.default)('uk-main__heading', className);
  const id = _react.default.useRef((0, _useRandomId.default)(controlledId)).current;
  return /*#__PURE__*/_react.default.createElement(Tag, _extends({
    className: classes,
    id: id,
    ref: ref
  }, attributes), /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-main__title"
  }, /*#__PURE__*/_react.default.createElement("h1", {
    tabIndex: "0"
  }, title), subtitle && /*#__PURE__*/_react.default.createElement("small", null, subtitle)), children);
});
SectionHeading.propTypes = {
  /**
   * Required HTML tag
   */
  tag: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string]).isRequired,
  /**
   * Title of the section heading
   */
  title: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]).isRequired,
  /**
   * Subtitle of the section heading
   */
  subtitle: _propTypes.default.string,
  /**
   * ID of the SectionHeading
   * NB: the ID will be randomly generated if not set.
   */
  id: _propTypes.default.string
};
SectionHeading.defaultProps = {
  id: '',
  tag: 'header',
  subtitle: ''
};
var _default = exports.default = SectionHeading;